import { Controller } from "@hotwired/stimulus"

// Closes a <details> dropdown when you click outside it.
export default class extends Controller {
  connect() {
    this.outside = (e) => { if (!this.element.contains(e.target)) this.element.removeAttribute("open") }
    document.addEventListener("click", this.outside)
  }

  disconnect() {
    document.removeEventListener("click", this.outside)
  }
}
